module.exports = __webpack_public_path__ + "static/studded_leather_armor-a999d3944aa886484d1338f33a60c9ee.jpg";